export default {
  leads: {
    title: 'Leads',
    subtitle: 'Choisissez une zone pour consulter et ajuster ses règles de vente.',
    helpLabel: 'Comprendre la vente de leads',
    help: 'Pilotez la vente de leads par région de départ. Sélectionnez les départements éligibles et les flux Local, National et Tous les autres. Chaque région possède ses propres règles.',
    editDescription: 'Modifiez les départements et les flux de vente de cette région.',
  },
  online: {
    title: 'Online',
    subtitle: 'Choisissez une zone pour consulter et ajuster l’accès au parcours Online.',
    helpLabel: 'Comprendre le flux Online',
    help: 'Ouvrez le parcours autonome par région de départ. Sélectionnez les départements éligibles et les flux Local, National et Tous les autres. Chaque région possède ses propres règles.',
    editDescription: 'Modifiez les départements et les flux du parcours Online dans cette région.',
  },
  departments: 'Départements {list}',
  noDepartment: 'Aucun département',
  state: {
    on: 'Activé',
    off: 'Désactivé',
    short: {
      on: 'On',
      off: 'Off',
    },
    enable: 'Activer {name}',
    disable: 'Désactiver {name}',
    enabled: 'Région activée : {name}.',
    disabled: 'Région désactivée : {name}.',
  },
  categories: {
    Local: 'Local',
    National: 'National',
    Autres: 'Tous les autres',
  },
  categoryTitles: {
    Local: 'Flux Local',
    National: 'Flux National',
    Autres: 'Tous les autres',
  },
  categoryHelpers: {
    Local: 'Distance inférieure à 100 km.',
    National: 'Distance comprise entre 100 et 299 km.',
    Autres: 'Distance de 300 km et plus.',
  },
  fluxDisabled: 'Désactivé',
  noFluxInCategory: 'Aucun flux de cette catégorie dans l’API One.',
  lastUpdate: 'Modifiée le {date} par {author}',
  created: 'Créée le {date} par {author}',
  lastChange: 'Le {date} par {author}',
  history: 'Historique de {name}',
  edit: 'Modifier les flux',
  add: 'Ajouter une région',
  empty: {
    title: 'Aucune zone trouvée',
    text: 'Ajoutez une région pour configurer ses flux.',
    search: 'Aucune région ne correspond à « {query} ».',
    filters: 'Aucune région ne correspond aux filtres.',
  },
  filters: {
    label: 'Filtrer les régions',
    name: 'Nom',
    namePlaceholder: 'Nom de la région',
    departments: 'Départements',
    flux: 'Flux',
    all: 'Tous',
    status: 'Statut',
    statuses: {
      all: 'Toutes',
      active: 'Activées',
      archived: 'Archivées',
    },
    reset: 'Réinitialiser les filtres',
  },
  actions: {
    archive: 'Archiver',
    unarchive: 'Réactiver',
    delete: 'Supprimer',
  },
  delete: {
    title: 'Supprimer la région',
    confirm: 'Supprimer {name} et tout son historique ? Cette suppression est définitive.',
    submit: 'Supprimer définitivement',
    done: 'Région supprimée : {name}.',
  },
  loadError: 'Les régions n’ont pas pu être chargées.',
  saved: 'Règles enregistrées : {name}.',
  createdNotice: 'Région ajoutée : {name}.',
  addModal: {
    step: 'Étape {step} sur 2',
    stepOne: 'Choisissez la région et ses départements éligibles.',
    stepTwo: 'Configurez les premiers flux avant son activation.',
    region: 'Région',
    regionPlaceholder: 'Sélectionner une région',
    eligible: 'Départements éligibles',
    configure: 'Configurer les flux',
    submit: 'Ajouter la région',
  },
  editModal: {
    departmentsTitle: 'Départements éligibles',
    departmentsHelper: 'Sélection limitée à la région administrative.',
    departmentsHelperAll: 'Tous les départements de l’API One.',
  },
};
